import type { ReactElement, ReactNode } from 'react';

export type BadgeTone = 'danger' | 'warn' | 'success' | 'info' | 'neutral';

export interface BadgeProps {
  tone: BadgeTone;
  children: ReactNode;
}

const TONE_CLASSES: Record<BadgeTone, string> = {
  danger: 'bg-danger-bg text-danger border-danger-line',
  warn: 'bg-warn-bg text-warn border-warn-line',
  success: 'bg-success-bg text-success border-success-line',
  info: 'bg-info-bg text-info border-info-line',
  neutral: 'bg-surface text-ink border-line'
};

export function Badge({ tone, children }: BadgeProps): ReactElement {
  return (
    <span className={`m-0 inline-flex items-center px-2 py-1 text-xs font-ui border border-solid rounded-pill ${TONE_CLASSES[tone]}`.trim()}>
      {children}
    </span>
  );
}
